import { Alert, AlertTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContactsSupport } from '../../components/ContactsSupport';

export const BankConnectionForTrial = () => {
  const { t } = useTranslation('bank-connection');
  return (
    <Alert severity={'warning'} sx={{ p: 4, backgroundColor: 'background.paper' }} variant={'outlined'}>
      <AlertTitle>{t('trial.title')}</AlertTitle>
      <Typography variant={'subtitle1'} whiteSpace={'break-spaces'}>
        {t('trial.description')}
      </Typography>
      <ContactsSupport sx={{ mt: 4 }} />
    </Alert>
  );
};
